module.exports = __webpack_public_path__ + "img/59_20.029ca96a.png";